import CloseButton from "../../../UI/CloseButton/CloseButton";

import "./styles.scss";

const IntegrationMarketModal = ({ title = "", onBack = null, onClose = null, children }) => {
  return (
    <div className="integration-market-backdrop" onClick={onClose}>
      <div className="integration-market-modal border" onClick={(e) => e.stopPropagation()}>
        <div className="integration-market-modal__heading">
          {onBack ? (
            <div className="integration-market-modal__back-button" onClick={onBack}>
              &larr;
            </div>
          ) : null}

          <h3 className="integration-market-modal__title">{title}</h3>

          {onClose ? (
            <div className="integration-market-modal__close-button">
              <CloseButton onClick={onClose} />
            </div>
          ) : null}
        </div>

        {children}
      </div>
    </div>
  );
};

export default IntegrationMarketModal;
